import React from "react";
import DatePickerComp, { registerLocale } from "react-datepicker";
import en from "date-fns/locale/en-US";
import PropTypes from "prop-types";
import styled from "styled-components";
import "react-datepicker/dist/react-datepicker.css";
import InputAdornment from "@material-ui/core/InputAdornment";
import { Input, CalenderIcon } from ".";
registerLocale("en", en);

const CustomInput = React.forwardRef(
  ({ onClick, value, placeholder, disabled, isInvalid }, ref) => (
    <div ref={ref} role="button" tabIndex={0} onClick={onClick}>
      <Input
        value={value}
        placeholder={placeholder}
        disabled={disabled}
        data-test="date-input-field"
        class={isInvalid ? "date-input-div is-invalid" : "date-input-div"}
        isInvalid={isInvalid}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <CalenderIcon />
            </InputAdornment>
          )
        }}
      />
    </div>
  )
);

CustomInput.propTypes = {
  onClick: PropTypes.func,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  isInvalid: PropTypes.bool
};

CustomInput.defaultProps = {
  onClick: () => {},
  value: "",
  placeholder: "",
  disabled: false,
  isInvalid: false
};

export const DatePickerCompnent = ({
  className,
  placeholder,
  disabled,
  isInvalid,
  ...rest
}) => {
  return (
    <div className={className}>
      <DatePickerComp
        disabled={disabled}
        placeholderText="DD/MM/YYYY"
        showYearDropdown
        showMonthDropdown
        locale="en"
        format={null}
        dateFormat="dd/MM/yyyy"
        customInput={
          <CustomInput
            placeholder={placeholder}
            disabled={disabled}
            isInvalid={isInvalid}
          />
        }
        {...rest}
      />
    </div>
  );
};

DatePickerCompnent.propTypes = {
  className: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  isInvalid: PropTypes.bool,
  selected: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)])
};

DatePickerCompnent.defaultProps = {
  className: "",
  placeholder: "",
  disabled: false,
  isInvalid: false,
  selected: ""
};

export const DatePicker = styled(DatePickerCompnent)`
  .react-datepicker-wrapper {
    display: block;
    cursor: pointer;
    .react-datepicker__input-container {
      display: block;
      cursor: pointer;
    }
    input[type="text"] {
      cursor: pointer;
    }
    .react-datepicker__close-icon {
      right: 39px;
    }
  }
  .react-datepicker__year-option--selected,
  .react-datepicker__month-option--selected,
  .react-datepicker__month-year-option--selected {
    left: 5px;
  }
  .react-datepicker__month-dropdown,
  .react-datepicker__year-dropdown {
    width: 100px;
    position: absolute !important;
    left: 0;
    top: 10px;
  }
  input {
    color: transparent;
    text-shadow: 0 0 0
      ${/* istanbul ignore next */ ({ theme }) => theme.palette.BLACK};
  }
  .is-invalid {
    div {
      div {
        z-index: 1;
      }
    }
    fieldset {
      border-color: #fc192e !important;
      background: #fef4f4 !important;
    }
  }

  .calender-icon {
    position: absolute;
    right: 8px;
    top: 8px;
  }
`;
